import { html } from 'lit-html';
import { AddRecommendationItemAction } from '../actions/add_recommendation_item_action'

export const Button = () => {
  let isDisabled = true;
  let disabledClass = "is-disabled";
  // フォルダが選択されている場合「選択したフォルダに登録」ボタン活性
  if (document.querySelector('input[name="selected-folder"]:checked')) {
    isDisabled = false;
    disabledClass = "";
  }
  return html`
  <button id="registration-modal-close" class="m-btn -base -middle" type="button" data-micromodal-close="true">
    <span class="m-btn_inner"><span class="m-btn_text">登録せずに閉じる</span></span>
  </button>
  <button id="js-add-recommendation-item-button" class="m-btn -tertiary -middle js-addfolderBtn ${disabledClass}" ?disabled="${isDisabled}" type="button"
    @click="${() => AddRecommendationItemAction.registerWithSelectedFolder()}"
  >
    <span class="m-btn_inner"><span class="m-btn_text">選択したフォルダに登録</span></span>
  </button>
`;
}

export const ButtonSP = () => html`
<button class="m-btn -tertiary -middle is-disabled js-addfolderBtn" disabled="" type="button" data-micromodal-close="true"
 @click="${() => AddRecommendationItemAction.registerWithSelectedFolder()}"
>
  <span class="m-btn_inner">
    <span class="m-btn_text">選択したフォルダに登録</span>
  </span>
</button>
`;

export const CreateFolderButton = () => html`
  <button class="m-btn -base -short" type="button" data-micromodal-close="true">
    <span class="m-btn_inner"><span class="m-btn_text">作成せずに閉じる</span></span>
  </button>
  <button id="create-folder-modal-close" type="button" data-micromodal-close="true" hidden></button>
  <button class="m-btn -tertiary -short" type="button" data-micromodal-trigger="modal-SLPSRC017-03"
          ?disabled=${AddRecommendationItemAction.isFolderNameEmpty()}
          @click="${() => AddRecommendationItemAction.createFolderRequest()}"
  >
    <span class="m-btn_inner"><span class="m-btn_text">追加</span></span>
  </button>
`;

// 白枠ボタンの推奨品ボタンは上下の構造で、lit-htmlの外部のdivよりmarginが失効するためmargin-topを追加する必要
export const AddRecommendationButton = () => html`
<button class="m-btn -small" style="margin-top: 0.5rem" type="button" data-reinit-micromodal-trigger="add_recommendation_item"
 @click="${(e) => AddRecommendationItemAction.openModal(e)}"
>
  <span class="m-btn_inner">
    <span class="m-btn_text">推奨品に登録</span>
  </span>
</button>
`;

export const AddRecommendationVariationButton = () => html`
<button class="m-btn -tertiary -small -auto-16" type="button" data-reinit-micromodal-trigger="add_recommendation_item"
 @click="${(e) => AddRecommendationItemAction.openModal(e)}"
>
  <span class="m-btn_inner">
    <span class="m-btn_text">バリエーションを推奨品に登録</span>
  </span>
</button>
`;

export const AddRecommendationVariationItemButton = () => html`
<button class="m-btn -small -base" type="button" data-reinit-micromodal-trigger="add_recommendation_item"
 @click="${(e) => AddRecommendationItemAction.openModal(e)}"
>
  <span class="m-btn_inner">
    <span class="m-btn_text">企業推奨品登録</span>
  </span>
</button>
`;
